import React, { useState } from "react";
import { LoginImage, Logo, MailIcon } from "../../common/imagePath";
import { Helmet } from "react-helmet";
import { useNavigate, Link } from "react-router-dom";
import axios from "axios";

import Loader from "../../components/Loader/Loader";
import { toastError, toastSuccess } from "../../common/Toast";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import config from "../../config/config";

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false);
  let navigate = useNavigate();

  const schema = Yup.object().shape({
    email: Yup.string().required("Email is required").email("Email is invalid"),
  });

  const handleSubmit = async (event) => {
    // setLoading(true);
    axios
      .post(
        `${config.authenticationBaseUrl}/users/forgotpassword`,
        {
          emailid: event.email,
        },
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
          },
        }
      )
      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          console.log("res: ", res.data.ResponseMessage);
          const Message = res.data.ResponseMessage;
          // setLoading(false);

          toastSuccess(Message);
          // navigate("/resetpassword");
        } else if (
          res.data.ResponseCode === "ERROR" &&
          res.data.ResponseID === -1
        ) {
          toastError("Invalid Email");
        } else {
          toastError("Something went wrong, Try Again!!!");
        }
      })
      .catch((error) => { });
  };

  return (
    <>
      <Loader loading={loading} />
      <div className="main-wrapper">
        <Helmet>
          <title>Forgot Password - Sonar POS</title>
          <meta name="description" content="ForgetPassword page" />
        </Helmet>
        <div className="account-content">
          <div className="login-wrapper">
            <div className="login-content">
              <div className="login-userset ">
                <Formik
                  initialValues={{ email: "" }}
                  validationSchema={schema}
                  onSubmit={handleSubmit}
                >
                  {({ values, errors, touched, handleChange, handleBlur }) => (
                    <Form>
                      <div className="login-logo">
                        <img src={Logo} alt="img" />
                      </div>
                      <div className="login-userheading">
                        <h3>Forgot password?</h3>
                        <h4>
                          Don't worry! it happens. Please enter the address{" "}
                          <br />
                          associated with your account.
                        </h4>
                      </div>

                      <div className="form-login">
                        <label>Email</label>
                        <div className="form-addons">
                          <Field
                            type="text"
                            name="email"
                            className={` ${errors.email ? "is-invalid" : ""}`}
                            placeholder="Enter your email address"
                            value={values.email}
                            onBlur={handleBlur}
                            onChange={handleChange}
                          />
                          <img src={MailIcon} alt="img" />
                          <div className="invalid-feedback">
                            {touched.email && errors.email ? errors.email : ""}
                          </div>
                        </div>
                      </div>
                      {/* {errorMsg && (
                        <div className="form-login">
                          <span className="error">{errorMsg}</span>
                        </div>
                      )} */}
                      <div className="form-login">
                        <button type="submit" className="btn btn-login">
                          Submit
                        </button>
                      </div>
                    </Form>
                  )}
                </Formik>
              </div>
            </div>
            <div className="login-img">
              <img src={LoginImage} alt="img" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ForgotPassword;
